










import NoUISlider from '@/components/NoUISlider.vue'

export default
    components: { NoUISlider }

    data: ->
        config:
            animate: false
            animationDuration: 100
            orientation: 'vertical'
            tooltips: true
            step: 1
            format:
                to: (value) ->
                    return parseInt(value)
                from: (value) ->
                    return Number(value)
            range:
                'min': 1
                'max': 1000

    computed:
        topindex:
            get: ->
                return [@$store.state.display.topindex]
            set: (values) ->
                @$store.commit('display/SET_TOPINDEX', values[0])
